import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";

export class memberTravelCoordinator {
	private memberBase:any = new memberPortal();

	/**
	 * [initTables description]
	 */
	initTables(): void {
		let _self = this;

		let travelCoordinatorTable = $('#members--travel-coordinator table');
		_self.memberBase.initTables(travelCoordinatorTable);
	}

	/**
	 * [hookWarningNote description]
	 * hide add button and show warning if table has 2 entries
	 * - by default both the add button and error message should be hidden
	 */
	hookWarningNote(): void {
		let _self = this;

		let addBtn = $('#add-travel-coordinator-btn');
		let fullNote = $('#travel-coordinator-full-warning');
		let travelCoordinatorTable = $.fn.dataTable.Api('#members--travel-coordinator table');

		if (travelCoordinatorTable.data().length > 1) {
			$(".travelcoordinator").prev().find(".cta-button a.btn")
			.blur()
			.addClass('btn-disabled')
			.attr({
				'href'    : 'javascript:void(0)',
				'disabled': 'disabled',
				'title'   : 'You can only nominate up to two travel coordinators'
			});
		}

		// if (travelCoordinatorTable.data().length > 1) {
		// 	fullNote.fadeIn();
		// } else {
		// 	addBtn.fadeIn();
		// }
	}

	deleteButton() {
		let _self = this;
		let deleteBtn:any = $(".deleteTravelCoordinator");

		deleteBtn.on("click",function() {
			let coordinatorId = $(this).attr("data-coordinatorId");
			let data:any = {
				'id': coordinatorId,
				'action': 'delete'
			};

			$.ajax({
				type: 'POST',
				url: 	'/bin/services/new/travelcoordinator',
				data: data,
				success: function(msg:any) {
					_self.redirectUser(msg);
					if (msg === 'OK') {
						location.reload();
					}
				},
				error: function(error:any) {
					console.log(error);
				}
			});
		});
	}

	redirectUser(msg:any) {
		if (msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}

}

let scope:Element = document.querySelector('#members--travel-coordinator table');

if (scope) {
	try {
	let membertravelcoordinator = new memberTravelCoordinator();
	membertravelcoordinator.initTables();
	membertravelcoordinator.hookWarningNote();
	membertravelcoordinator.deleteButton();
	} catch(e) {console.error(e);}
}
